export const NavLinks = {
  "About": {
    "name": "Home",
    "path": "/me"
  },
  "Resume": {
    "name": "Resume",
    "path": "/resume"
  },
  "Activities": {
    "name": "Activities",
    "path": "/activities"
  }
}